export const SEARCH_ENABLED_ITEMS_COUNT_DEFAULT = 10;
